import produce from 'immer';
import * as actionTypes from '../constants/action-types';

const initialState = {
    deviceList: {
        isRequesting: false,
        payload: []
    },
    sensorListById: {
        isRequesting: false,
        payload: {}
    },
    commandList: {
        isRequesting: false,
        payload: []
    },
    sendCommandById: {},
    hardwareList: {
        isRequesting: false,
        payload: []
    },
    hardwareActivity: {},
    gpsSensorDataById: {},
    qappLogsById: {},
    boardList: {
        isRequesting: false,
        payload: []
    },
    hardwareType: {
        isRequesting: false,
        payload: []
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.HARDWARE_GET_DEVICE_LIST_REQUEST: {
            state = {
                ...state,
                deviceList: { isRequesting: true, payload: [] },
                sensorListById: { ...state.sensorListById, payload: {} }
            };
            break;
        }
        case actionTypes.HARDWARE_GET_DEVICE_LIST: {
            const payload = action.payload ? action.payload : [];
            const deviceList = payload.map((e) => {
                const { equipment_group_uuid, equipment_group_name, device_uuid, operator_name,
                    model, imei, can_code, app_version, os_version, img, status_id, network_name, network_uuid } = e.current_hardware_info || {};
                return {
                    hardwareId: e.hardware_uuid,
                    hardwareTypeid: e.hardware_type_id,
                    hardwareTypeName: e.hardware_type_name,
                    egId: equipment_group_uuid,
                    egName: equipment_group_name,
                    deviceId: device_uuid,
                    deviceName: e.hardware_name,
                    statusId: status_id,
                    operatorName: operator_name,
                    img: { ic: ((img || {}).ic) || null },
                    deviceDetail: {
                        model: model,
                        imei: imei,
                        canCode: can_code,
                        appVersion: app_version,
                        osVersion: os_version,
                        networkName: network_name ? network_name : null,
                        networkUuid: network_uuid ? network_uuid : null
                    }
                }
            });
            state = {
                ...state,
                deviceList: { isRequesting: false, payload: deviceList },
                sensorListById: { ...state.sensorListById, payload: {} }
            };
            break;
        }
        case actionTypes.UPDATE_HARDWARE_LIST: {
            const payload = action.payload ? action.payload : [];

            state = {
                ...state,
                deviceList: { isRequesting: false, payload },
            };
            break;
        }
        case actionTypes.GET_LATEST_SENSOR_LIST_REQUEST: {
            state = {
                ...state,
                sensorListById: {
                    isRequesting: true,
                    payload: {}
                }
            };
            break;
        }
        case actionTypes.GET_LATEST_SENSOR_LIST: {
            state = {
                ...state,
                sensorListById: {
                    isRequesting: false,
                    payload: action.payload ? action.payload : {}
                }
            };
            break;
        }
        case actionTypes.UNASSIGN_CANCODE_SUCCESS: {
            const { deviceId } = action.payload;
            const deviceList = (state.deviceList.payload || []).map(e => {
                if (e.deviceId === deviceId) e.deviceDetail.canCode = null;
                return e;
            });

            const hardwareList = (state.hardwareList.payload || []).map(e => {
                const hardwareInfo = e.current_hardware_info || {};
                if (hardwareInfo.device_uuid === deviceId) {
                    e.current_hardware_info = { ...hardwareInfo, can_code: null };
                }
                return e;
            });

            state = produce(state, s => {
                s.deviceList.payload = deviceList;
                s.hardwareList.payload = hardwareList;
            });
            break;
        }
        case actionTypes.GET_DEVICE_COMMAND_LIST_REQUEST: {
            state = {
                ...state,
                commandList: {
                    isRequesting: true,
                    payload: []
                }
            };
            break;
        }
        case actionTypes.GET_DEVICE_COMMAND_LIST: {
            state = {
                ...state,
                commandList: {
                    isRequesting: false,
                    payload: action.payload ? action.payload : []
                }
            };
            break;
        }
        case actionTypes.SEND_DEVICE_COMMAND_REQUEST: {
            const { device_uuid, command, parameter } = action.payload;
            if (!device_uuid) return;

            state = {
                ...state,
                sendCommandById: {
                    ...state.sendCommandById,
                    [device_uuid]: {
                        isRequesting: true,
                        activeCommand: command,
                        activeParameter: parameter,
                    }
                }
            };
            break;
        }
        case actionTypes.SEND_DEVICE_COMMAND_RESPONSE: {
            const { deviceId, error, success, response } = action.payload;
            if (!deviceId) return;

            state = {
                ...state,
                sendCommandById: {
                    ...state.sendCommandById,
                    [deviceId]: {
                        ...state.sendCommandById[deviceId],
                        isRequesting: false,
                        errorMessage: error ? error : null,
                        successMessage: success ? success : null,
                        commandResponse: response ? response : null
                    }
                }
            };
            break;
        }
        case actionTypes.CLEAR_SEND_DEVICE_COMMAND: {
            if (!action.deviceId) return;

            state = {
                ...state,
                sendCommandById: {
                    ...state.sendCommandById,
                    [action.deviceId]: {
                        ...state.sendCommandById[action.deviceId],
                        errorMessage: null,
                        successMessage: null,
                        commandResponse: null
                    }
                }
            };
            break;
        }
        case actionTypes.GET_HARDWARE_LIST_REQUEST: {
            state = {
                ...state,
                hardwareList: {
                    isRequesting: true,
                    payload: []
                },
                hardwareActivity: initialState.hardwareActivity,
                gpsSensorDataById: initialState.gpsSensorDataById,
                qappLogsById: initialState.qappLogsById
            };
            break;
        }
        case actionTypes.GET_HARDWARE_LIST: {
            const payload = action.payload ? action.payload : [];
            state = {
                ...state,
                hardwareList: { isRequesting: false, payload: payload }
            };
            break;
        }
        case actionTypes.GET_HARDWARE_ACTIVITY_LIST_REQUEST: {
            state = {
                ...state,
                hardwareActivity: {
                    ...state.hardwareActivity,
                    [`${action.hardwareId}`]: { isRequesting: true, payload: [] }
                }
            };
            break;
        }
        case actionTypes.GET_HARDWARE_ACTIVITY_LIST: {
            const payload = action.payload ? action.payload : [];
            state = {
                ...state,
                hardwareActivity: {
                    ...state.hardwareActivity,
                    [`${action.hardwareId}`]: { isRequesting: false, payload: payload }
                }
            };
            break;
        }
        case actionTypes.GET_GPS_SENSOR_DATA_REQUEST: {
            state = {
                ...state,
                gpsSensorDataById: {
                    ...state.gpsSensorDataById,
                    [`${action.hardwareId}`]: { isRequesting: true, payload: [] }
                }
            };
            break;
        }
        case actionTypes.GET_GPS_SENSOR_DATA: {
            const payload = action.payload ? action.payload : [];
            state = {
                ...state,
                gpsSensorDataById: {
                    ...state.gpsSensorDataById,
                    [`${action.hardwareId}`]: { isRequesting: false, payload: payload }
                }
            };
            break;
        }
        case actionTypes.GET_QAPP_LOGS_REQUEST: {
            state = {
                ...state,
                qappLogsById: {
                    ...state.qappLogsById,
                    [`${action.hardwareId}`]: { isRequesting: true, payload: [] }
                }
            };
            break;
        }
        case actionTypes.GET_QAPP_LOGS: {
            const payload = action.payload ? action.payload : [];
            state = {
                ...state,
                qappLogsById: {
                    ...state.qappLogsById,
                    [`${action.hardwareId}`]: { isRequesting: false, payload: payload }
                }
            };
            break;
        }
        case actionTypes.GET_BOARD_LIST_REQUEST: {
            state = {
                ...state,
                boardList: {
                    ...state.boardList,
                    isRequesting: true, payload: []
                }
            };
            break;
        }
        case actionTypes.GET_BOARD_LIST: {
            const payload = action.payload ? action.payload : [];
            state = {
                ...state,
                boardList: {
                    ...state.boardList,
                    isRequesting: false, payload: payload
                }
            };
            break;
        }
        case actionTypes.GET_HARDWARE_TYPE_REQUEST: {
            state = {
                ...state,
                hardwareType: {
                    ...state.hardwareType,
                    isRequesting: true, payload: []
                }
            };
            break;
        }
        case actionTypes.GET_HARDWARE_TYPE: {
            const payload = action.payload ? action.payload : [];
            state = {
                ...state,
                hardwareType: {
                    ...state.hardwareType,
                    isRequesting: false, payload: payload
                }
            };
            break;
        }
        default:
            break;
    }
    return state;
};